module.exports = __webpack_public_path__ + "media/Mid-Tom.587b84b3.wav";